"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AemMapComponent = exports.AemMap = void 0;

var _resourcesColumnListUi = _interopRequireDefault(require("./components/resources-column-list/resources-column-list-ui"));

var _resourcesColumnContainerUi = _interopRequireDefault(require("./components/resources-column-container/resources-column-container-ui"));

var _boxUi = _interopRequireDefault(require("./components/box/box-ui"));

var _tabsUi = _interopRequireDefault(require("./components/tabs/tabs-ui"));

var _columnLayoutUi = _interopRequireDefault(require("./components/column-layout/column-layout-ui"));

var _sectionHeadline = _interopRequireDefault(require("./components/section-headline/section-headline"));

var _expanderUi = _interopRequireDefault(require("./components/expander/expander-ui"));

var _faqHub = _interopRequireDefault(require("./components/faq-hub/faq-hub"));

var _storeLocatorUi = _interopRequireDefault(require("./components/store-locator/store-locator-ui"));

var _gallery = _interopRequireDefault(require("./components/gallery/gallery"));

var _photoLinks = _interopRequireDefault(require("./components/photo-links/photo-links"));

var _linksGrid = _interopRequireDefault(require("./components/links-grid/links-grid"));

var _quote = _interopRequireDefault(require("./components/quote/quote"));

var _promo = _interopRequireDefault(require("./components/promo/promo"));

var _photoLayout = _interopRequireDefault(require("./components/photo-layout/photo-layout"));

var _buttonUi = _interopRequireDefault(require("./components/button/button-ui"));

var _carouselUi = _interopRequireDefault(require("./components/carousel/carousel-ui"));

var _colUi = _interopRequireDefault(require("./components/col/col-ui"));

var _containerUi = _interopRequireDefault(require("./components/container/container-ui"));

var _contentUi = _interopRequireDefault(require("./components/content/content-ui"));

var _featureCardUi = _interopRequireDefault(require("./components/feature-card/feature-card-ui"));

var _heroSlideUi = _interopRequireDefault(require("./components/hero-slide/slide-a/hero-slide-ui"));

var _heroSlideUi2 = _interopRequireDefault(require("./components/hero-slide/slide-b/hero-slide-ui"));

var _heroSlideUi3 = _interopRequireDefault(require("./components/hero-slide/video-slide/hero-slide-ui"));

var _hrUi = _interopRequireDefault(require("./components/hr/hr-ui"));

var _iconGridUi = _interopRequireDefault(require("./components/icon-grid/icon-grid-ui"));

var _imageUi = _interopRequireDefault(require("./components/image/image-ui"));

var _linkUi = _interopRequireDefault(require("./components/link/link-ui"));

var _mediaParagraphUi = _interopRequireDefault(require("./components/media-paragraph/media-paragraph-ui"));

var _productCarouselPwa = _interopRequireDefault(require("./components/product-carousel/product-carousel-pwa"));

var _rowUi = _interopRequireDefault(require("./components/row/row-ui"));

var _textUi = _interopRequireDefault(require("./components/text/text-ui"));

var _titleUi = _interopRequireDefault(require("./components/title/title-ui"));

var _headerOneUi = _interopRequireDefault(require("./components/header-one/header-one-ui"));

var _variableColumnUi = _interopRequireDefault(require("./components/variable-column/variable-column-ui"));

var _colorCarousel = _interopRequireDefault(require("./components/color-carousel/color-carousel"));

var _colorChart = _interopRequireDefault(require("./components/color-chart/color-chart"));

var _colorPaletteFilterUi = _interopRequireDefault(require("./components/color-palette-filter/color-palette-filter-ui"));

var _AemMapComponent;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AemMap;
exports.AemMap = AemMap;

(function (AemMap) {
  AemMap["TABS"] = "aem-integration/components/tabs";
  AemMap["COLUMN_LAYOUT"] = "aem-integration/components/column-layout";
  AemMap["SECTION_HEADLINE"] = "aem-integration/components/section-headline";
  AemMap["FAQ_HUB"] = "aem-integration/components/faq-hub";
  AemMap["EXPANDER"] = "aem-integration/components/expander";
  AemMap["STORE_LOCATOR"] = "aem-integration/components/store-locator";
  AemMap["GALLERY"] = "aem-integration/components/gallery";
  AemMap["PHOTO_LINKS"] = "aem-integration/components/photo-links";
  AemMap["LINKS_GRID"] = "aem-integration/components/links-grid";
  AemMap["RESOURCES_COLUMN_LIST"] = "aem-integration/components/resources-column-list";
  AemMap["RESOURCES_COLUMN_CONTAINER"] = "aem-integration/components/resources-column-container";
  AemMap["QUOTE"] = "aem-integration/components/quote";
  AemMap["PROMO"] = "aem-integration/components/promo";
  AemMap["PHOTO_LAYOUT"] = "aem-integration/components/photo-layout";
  AemMap["BOX"] = "aem-integration/components/box";
  AemMap["BUTTON"] = "aem-integration/components/button";
  AemMap["CAROUSEL"] = "aem-integration/components/carousel";
  AemMap["COL"] = "aem-integration/components/col";
  AemMap["CONTAINER"] = "aem-integration/components/container";
  AemMap["CONTENT"] = "aem-integration/components/content";
  AemMap["FEATURE_CARD"] = "aem-integration/components/feature-card";
  AemMap["HERO_SLIDE_A"] = "aem-integration/components/hero-slide";
  AemMap["HERO_SLIDE_B"] = "aem-integration/components/half-hero-slide";
  AemMap["HERO_VIDEO_SLIDE"] = "aem-integration/components/hero-video-banner";
  AemMap["HR"] = "aem-integration/components/hr";
  AemMap["ICON_GRID"] = "aem-integration/components/icon-grid";
  AemMap["IMAGE"] = "aem-integration/components/image";
  AemMap["LINK"] = "aem-integration/components/link";
  AemMap["MEDIA_PARAGRAPH"] = "aem-integration/components/media-paragraph";
  AemMap["PRODUCT_CAROUSEL"] = "aem-integration/components/product-carousel";
  AemMap["ROW"] = "aem-integration/components/row";
  AemMap["TEXT"] = "aem-integration/components/text";
  AemMap["TITLE"] = "aem-integration/components/title";
  AemMap["VARIABLE_COLUMN"] = "aem-integration/components/variable-column";
  AemMap["COLOR_CAROUSEL"] = "aem-integration/components/color-carousel";
  AemMap["COLOR_CHART"] = "aem-integration/components/color-chart";
  AemMap["COLOR_PALETTE_FILTER"] = "aem-integration/components/color-palette-filter";
  AemMap["HEADER_ONE"] = "aem-integration/components/header-one";
})(AemMap || (exports.AemMap = AemMap = {}));

var AemMapComponent = (_AemMapComponent = {}, _defineProperty(_AemMapComponent, AemMap.TABS, {
  component: _tabsUi.default,
  empty: {
    emptyLabel: 'Tabs',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.HEADER_ONE, {
  component: _headerOneUi.default,
  empty: {
    emptyLabel: 'Heading One',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.COLUMN_LAYOUT, {
  component: _columnLayoutUi.default,
  empty: {
    emptyLabel: 'Column Layout',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.SECTION_HEADLINE, {
  component: _sectionHeadline.default,
  empty: {
    emptyLabel: 'Section Headline',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.FAQ_HUB, {
  component: _faqHub.default,
  empty: {
    emptyLabel: 'FaqHub',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.EXPANDER, {
  component: _expanderUi.default,
  empty: {
    emptyLabel: 'Expander',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.STORE_LOCATOR, {
  component: _storeLocatorUi.default,
  empty: {
    emptyLabel: 'Store-locator',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.GALLERY, {
  component: _gallery.default,
  empty: {
    emptyLabel: 'Gallery',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.PHOTO_LINKS, {
  component: _photoLinks.default,
  empty: {
    emptyLabel: 'Photo Links',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.LINKS_GRID, {
  component: _linksGrid.default,
  empty: {
    emptyLabel: 'Links Grid',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.RESOURCES_COLUMN_LIST, {
  component: _resourcesColumnListUi.default,
  empty: {
    emptyLabel: 'Resources Column List',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.RESOURCES_COLUMN_CONTAINER, {
  component: _resourcesColumnContainerUi.default,
  empty: {
    emptyLabel: 'Resources Column Container',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.QUOTE, {
  component: _quote.default,
  empty: {
    emptyLabel: 'Quote',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.PROMO, {
  component: _promo.default,
  empty: {
    emptyLabel: 'Promo',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.PHOTO_LAYOUT, {
  component: _photoLayout.default,
  empty: {
    emptyLabel: 'Photo Layout',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.BOX, {
  component: _boxUi.default,
  empty: {
    emptyLabel: 'Box',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.BUTTON, {
  component: _buttonUi.default,
  empty: {
    emptyLabel: 'Button',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.CAROUSEL, {
  component: _carouselUi.default,
  empty: {
    emptyLabel: 'Carousel',
    isEmpty: function isEmpty(props) {
      return props.cqItemsOrder == null || props.cqItemsOrder.length === 0;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.COL, {
  component: _colUi.default,
  empty: {
    emptyLabel: 'Col',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.CONTAINER, {
  component: _containerUi.default,
  empty: {
    emptyLabel: 'Container',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.CONTENT, {
  component: _contentUi.default,
  empty: {
    emptyLabel: 'Content',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.FEATURE_CARD, {
  component: _featureCardUi.default,
  empty: {
    emptyLabel: 'Content',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.HERO_SLIDE_A, {
  component: _heroSlideUi.default,
  empty: {
    emptyLabel: 'Hero Slide A',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.HERO_SLIDE_B, {
  component: _heroSlideUi2.default,
  empty: {
    emptyLabel: 'Hero Slide B',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.HERO_VIDEO_SLIDE, {
  component: _heroSlideUi3.default,
  empty: {
    emptyLabel: 'Hero Video Slide B',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.HR, {
  component: _hrUi.default,
  empty: {
    emptyLabel: 'Hr',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.ICON_GRID, {
  component: _iconGridUi.default,
  empty: {
    emptyLabel: 'Icon grid',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.IMAGE, {
  component: _imageUi.default,
  empty: {
    emptyLabel: 'Image',
    isEmpty: function isEmpty(props) {
      return !props || !props.src;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.LINK, {
  component: _linkUi.default,
  empty: {
    emptyLabel: 'Link',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.MEDIA_PARAGRAPH, {
  component: _mediaParagraphUi.default,
  empty: {
    emptyLabel: 'Media paragraph',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.PRODUCT_CAROUSEL, {
  component: _productCarouselPwa.default,
  empty: {
    emptyLabel: 'Product carousel',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.ROW, {
  component: _rowUi.default,
  empty: {
    emptyLabel: 'Row',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.TEXT, {
  component: _textUi.default,
  empty: {
    emptyLabel: 'Text',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.TITLE, {
  component: _titleUi.default,
  empty: {
    emptyLabel: 'Title',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.VARIABLE_COLUMN, {
  component: _variableColumnUi.default,
  empty: {
    emptyLabel: 'Variable column',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.COLOR_CAROUSEL, {
  component: _colorCarousel.default,
  empty: {
    emptyLabel: 'Color carousel',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.COLOR_CHART, {
  component: _colorChart.default,
  empty: {
    emptyLabel: 'Color chart',
    isEmpty: function isEmpty(props) {
      return !props;
    }
  }
}), _defineProperty(_AemMapComponent, AemMap.COLOR_PALETTE_FILTER, {
  component: _colorPaletteFilterUi.default,
  empty: {
    emptyLabel: 'Color palette filter',
    isEmpty: function isEmpty(props) {
      return !props || !props.children;
    }
  }
}), _AemMapComponent);
exports.AemMapComponent = AemMapComponent;